import {
  deleteAccountMutation,
  removeAvatarMutation,
  // updateUserProfileMutation,
  // uploadAvatarMutation,
} from '@affine/graphql';
import {
  deleteEndpointToken,
  deleteEndpointUserId,
  writeEndpointToken,
  writeEndpointUserId,
} from '@affine/nbstore';
import { Store } from '@toeverything/infra';
// import { redirect } from 'react-router-dom';

import * as Sentry from '@sentry/react';

import type { GlobalState } from '../../storage';
import type { AuthSessionInfo } from '../entities/session';
import type { AuthProvider } from '../provider/auth';
import {
  // apiVersion, getUserUrl,
  RESPONSE_CODE,
} from '../server/config';
import {
  clearLoginCookieInfo,
  clearRepeatedLoginCookieInfo,
  getVisitorId,
  setLoginCookieInfo,
} from '../server/utils';
import type { FetchService } from '../services/fetch';
import type { GraphQLService } from '../services/graphql';
import type { ServerService } from '../services/server';
import { EventKeyMap, Tracker } from '@affine/core/utils/ga-tracking';

export interface AccountProfile {
  id: string;
  email: string;
  name: string;
  hasPassword: boolean;
  avatarUrl: string | null;
  emailVerified: string | null;
}

export class AuthStore extends Store {
  constructor(
    private readonly fetchService: FetchService,
    private readonly gqlService: GraphQLService,
    private readonly globalState: GlobalState,
    private readonly serverService: ServerService,
    private readonly authProvider: AuthProvider
  ) {
    super();
  }

  watchCachedAuthSession() {
    console.log(
      'aaaaaaaaawatchCachedAuthSession',
      this.serverService.server.id
    );
    return this.globalState.watch<AuthSessionInfo>(
      `${this.serverService.server.id}-auth`
    );
  }

  getCachedSetParentDomainCookie() {
    return this.globalState.get<string>(
      `${this.serverService.server.id}-set-parent-domain-cookie`
    );
  }

  setCachedSetParentDomainCookie() {
    this.globalState.set(
      `${this.serverService.server.id}-set-parent-domain-cookie`,
      'true'
    );
  }

  getCachedAuthSession() {
    return this.globalState.get<AuthSessionInfo>(
      `${this.serverService.server.id}-auth`
    );
  }

  setCachedAuthSession(session: AuthSessionInfo | null) {
    this.globalState.set(`${this.serverService.server.id}-auth`, session);
  }

  getClientNonce() {
    return this.globalState.get<string>('auth-client-nonce');
  }

  setClientNonce(nonce: string) {
    this.globalState.set('auth-client-nonce', nonce);
  }
  async fetchSession() {
    const url = `/api/auth/session`;
    const options: RequestInit = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const res = await this.fetchService.fetch(url, options);
    const data = (await res.json()) as {
      user?: AccountProfile | null;
    };
    if (!res.ok)
      throw new Error('Get session fetch error: ' + JSON.stringify(data));
    return data; // Return null if data empty
  }

  async signInMagicLink(email: string, token: string) {
    await this.authProvider.signInMagicLink(
      email,
      token,
      this.getClientNonce()
    );
  }

  // 拦截处理-上报
  private readonly loginSuccessTrack = async (params: object) => {
    return new Promise(resolve => {
      Tracker.track(EventKeyMap.signup_success, {
        ...params,
        event_callback: () => {
          resolve(true);
        },
      });

      setTimeout(() => {
        resolve(true);
      }, 2000);
    });
  };

  async signInOauth(code: string, platform: string) {
    const res = await this.authProvider.signInOauth(code, platform);
    if (res?.code === 0 && !res?.data?.errcode) {
      console.log('aaaaaaaRes', res);
      localStorage.setItem(
        'oauth_callback_user',
        JSON.stringify({
          auth: {
            token: res.data.token,
            user: { ...res.data.user, id: res.data.user.id.toString() },
          },
        })
      );
      const checkRes = await this.authProvider.checkUserHasRegistered(
        res.data?.token
      );
      if (checkRes?.code === 0 && !checkRes?.data?.errcode) {
        console.log('aaaaaaacheckRes', checkRes);
        if (checkRes?.data) {
          const visitorId = await getVisitorId();
          await setLoginCookieInfo({
            auth: {
              token: res.data.token,
              user: { ...res.data.user, id: res.data.user.id.toString() },
            },
            visitorId: visitorId,
          });
          await writeEndpointToken('/', res.data?.token);
          await writeEndpointUserId('/', res.data?.user.id.toString());
          localStorage.removeItem('oauth_callback_user');

          const user = res.data?.user;
          if (user) {
            Sentry.setUser({
              id: user.id?.toString(), // 你要用来检索的 ID
              username: user.nickname, // 可选
            });

            if (user.isFirstLogin) {
              await this.loginSuccessTrack({ platform });
            }
          }
        }

        return checkRes.data;
      } else {
        return false;
      }
    } else {
      throw new Error(
        `Sign in with OAuth failed: ${res?.msg || 'Unknown error'}`
      );
    }
  }
  async signInOauthInvite(inviteCode: string, localStorageKey: string) {
    const res = await this.authProvider.signInOauthInvite(
      inviteCode,
      localStorageKey
    );
    if (res?.code === 0 && !res?.data?.errcode) {
      console.log('aaaaaaaInviteRes', res);
      if (res?.data?.isActivated === 1) {
        const auth =
          JSON.parse(localStorage.getItem(localStorageKey) || '{}')?.auth || '';
        const visitorId = await getVisitorId();
        await setLoginCookieInfo({
          auth: { ...auth },
          visitorId: visitorId,
        });
        await writeEndpointToken('/', auth?.token);
        await writeEndpointUserId('/', auth?.user.id.toString());
        localStorage.removeItem(localStorageKey);

        const user = res.data?.user;
        if (user) {
          Sentry.setUser({
            id: user.id?.toString(), // 你要用来检索的 ID
            username: user.nickname, // 可选
          });

          if (user.isFirstLogin) {
            await this.loginSuccessTrack({ platform: 'invite-code' });
          }
        }
      }
      // if(res?.data?.actived){

      // }
      return res;
    } else {
      throw new Error(
        `Sign in with OAuth invite failed: ${res?.msg || 'Unknown error'}`
      );
    }
  }
  async getLoginCode(email: string) {
    const res = await this.authProvider.getLoginCode(email);
    return res;
  }
  async signInEmail({ email, code }: { email: string; code: string }) {
    const res = await this.authProvider.signInEmail({ email, code });
    if (res?.code === 0 && !res?.data?.errcode) {
      console.log('aaaaaaaRes111111', res);
      localStorage.setItem(
        'email_login_user',
        JSON.stringify({
          auth: {
            token: res.data.token,
            user: { ...res.data.user, id: res.data.user.id.toString() },
          },
        })
      );
      const checkRes = await this.authProvider.checkUserHasRegistered(
        res.data?.token
      );
      if (checkRes?.code === 0 && !checkRes?.data?.errcode) {
        console.log('aaaaaaacheckRes', checkRes);
        if (checkRes?.data) {
          const visitorId = await getVisitorId();
          await setLoginCookieInfo({
            auth: {
              token: res.data.token,
              user: { ...res.data.user, id: res.data.user.id.toString() },
            },
            visitorId: visitorId,
          });
          await writeEndpointToken('/', res.data?.token);
          await writeEndpointUserId('/', res.data?.user.id.toString());
          localStorage.removeItem('email_login_user');

          const user = res.data?.user;
          if (user) {
            Sentry.setUser({
              id: user.id?.toString(), // 你要用来检索的 ID
              username: user.nickname, // 可选
            });

            if (user.isFirstLogin) {
              await this.loginSuccessTrack({ platform: 'email' });
            }
          }
        }

        return { res: checkRes, checkStatus: checkRes.data };
      } else {
        return { res: checkRes, checkStatus: false };
      }
    } else {
      return { res, checkStatus: undefined };
    }
  }

  async getAuthInfoInServerSideV2() {
    return await this.authProvider.getAuthInfoInServerSideV2();
  }

  async signInPassword(credential: {
    email: string;
    password: string;
    verifyToken?: string;
    challenge?: string;
  }) {
    await this.authProvider.signInPassword(credential);
  }

  async signOut(userId: string | number, token: string) {
    clearRepeatedLoginCookieInfo();
    const res = await this.authProvider.signOut(userId, token);
    if (res.code === RESPONSE_CODE.SUCCESS) {
      clearLoginCookieInfo();
      await deleteEndpointToken('/');
      await deleteEndpointUserId('/');
      return { signOut: true };
      // sseInstance.setAuth(null);
    } else {
      console.log(res.msg);
      return { signOut: false };
    }
  }

  async destoryAccount(userId: string | number, token: string) {
    const res = await this.authProvider.destoryAccount(userId, token);
    if (res.code === RESPONSE_CODE.SUCCESS) {
      clearLoginCookieInfo();
      await deleteEndpointToken('/');
      await deleteEndpointUserId('/');
      return { signOut: true };
      // sseInstance.setAuth(null);
    } else {
      console.log(res.msg);
      return { signOut: false };
    }
  }

  async uploadAvatar(file: File) {
    await this.authProvider.setUserAvatar(file);
  }

  async removeAvatar() {
    await this.gqlService.gql({
      query: removeAvatarMutation,
    });
  }

  async updateLabel(name: string) {
    await this.authProvider.setUserInfo({ key: 'nickname', value: name });
  }

  async checkUserByEmail(email: string) {
    const res = await this.fetchService.fetch('/api/auth/preflight', {
      method: 'POST',
      body: JSON.stringify({ email }),
      headers: {
        'content-type': 'application/json',
      },
    });

    if (!res.ok) {
      throw new Error(`Failed to check user by email: ${email}`);
    }

    const data = (await res.json()) as {
      registered: boolean;
      hasPassword: boolean;
      magicLink: boolean;
    };

    return data;
  }

  async deleteAccount() {
    const res = await this.gqlService.gql({
      query: deleteAccountMutation,
    });
    return res.deleteAccount;
  }
}
